// extracted by mini-css-extract-plugin
module.exports = {"logo":"Icons_logo___KKWX","close":"Icons_close__gprSE","arrow":"Icons_arrow__WIzZv","scrollUp":"Icons_scrollUp__2mDrI","scrollDown":"Icons_scrollDown__3R8fa"};